import script from "./AttributeEditorTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AttributeEditorTable.vue?vue&type=script&setup=true&lang=js"

import "./AttributeEditorTable.vue?vue&type=style&index=0&id=b39b5d1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b39b5d1e"]])

export default __exports__